import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { QRCodeSVG } from 'qrcode.react';

/**
 * R148 - full-screen large QR so a patient can scan it from the screen. White QR panel on a solid
 * surface in both themes (scanners need a light background); Close button + Esc.
 */
export default function ShowToPatientOverlay({ counter, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`${counter.name} QR`}
      data-testid="show-to-patient"
      className="fixed inset-0 z-[1000] flex flex-col items-center justify-center gap-4 bg-slate-100 dark:bg-slate-900 p-4"
    >
      <h2 className="text-3xl font-bold text-slate-900 dark:text-slate-50 text-center">{counter.name}</h2>
      <div className="bg-white p-5 rounded-2xl border border-slate-300 leading-[0]">
        <QRCodeSVG value={counter.qrText} size={Math.min(480, Math.max(240, (typeof window !== 'undefined' ? window.innerHeight : 600) - 260))} level="M" />
      </div>
      <p className="text-xl font-semibold text-slate-800 dark:text-slate-100">Scan with your ABHA app</p>
      <button
        type="button"
        data-testid="show-to-patient-close"
        onClick={onClose}
        autoFocus
        className="px-6 py-2.5 rounded-lg border border-slate-500 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 text-base font-semibold hover:bg-slate-100 dark:hover:bg-slate-700"
      >
        Close
      </button>
    </div>,
    document.body,
  );
}
